module.exports = __webpack_public_path__ + "c62e58182c822bdfde3f570b8b7aa008.svg";